import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { delay, mergeMap, materialize, dematerialize } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { Product, Configuration, Entity, EntityRoute, IntegrationRoute, Date } from '../models';

@Injectable()
export class MocksInterceptor implements HttpInterceptor {
  constructor() { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return of(null)
      .pipe(
        mergeMap(() => {
          if (environment.envName !== 'mock') {
            return next.handle(request);
          }
          const body = typeof request.body === 'string' ? JSON.parse(request.body) : request.body;
          const params = new URLSearchParams(request.url.substr(request.url.indexOf('?')));

          /* if (request.url.match('/travels') && request.method === 'GET') {
            const responseTravels = require('./travels.json');
            return of(
              new HttpResponse({
                status: 200,
                body: responseTravels
              })
            );
          } */
          // End of method
          return next.handle(request);
        })
      )
      .pipe(materialize())
      .pipe(delay(500))
      .pipe(dematerialize());
  }
}
